// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=4687-3120

export default function EmptyState({ icon, title, description }) {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="bg-surface-container-low flex flex-col items-center gap-2 px-2 py-4 rounded-[10px] w-full">
        {icon && (
          <div className="size-11 flex items-center justify-center shrink-0">
            <div
              className="flex items-center justify-center"
              style={{
                filter: 'drop-shadow(0 0.5px 1px rgba(0,0,0,0.15)) drop-shadow(0 1px 3px rgba(0,0,0,0.15))',
              }}
            >
              {icon}
            </div>
          </div>
        )}
        <div className="flex flex-col gap-0.5 items-center w-full">
          <p className="text-[18px] font-semibold tracking-[0.54px] leading-normal text-on-surface">
            {title}
          </p>
          {description && (
            <p className="text-[15px] leading-5 text-on-surface-variant text-center">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
